import Swiper, { Pagination } from "swiper";

export default () => ({
  swiper: null,

  initSlider() {
    this.swiper = new Swiper(this.$refs.slider, {
      cssMode: true,
      preloadImages: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      modules: [Pagination],
    });
  },
});
